type JwtPayloadRecord = Record<string, unknown>;

const decodeBase64Url = (value: string): string | null => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (4 - (normalized.length % 4)) % 4;
  const padded = `${normalized}${'='.repeat(padLength)}`;
  if (typeof globalThis.atob !== 'function') {
    return null;
  }
  try {
    return globalThis.atob(padded);
  } catch {
    return null;
  }
};

export const describeJwtToken = (
  token: string | null,
): {
  tokenResolved: boolean;
  tokenLength: number | null;
  signatureSuffix: string | null;
  subject: string | null;
  issuedAtMs: number | null;
  expiresAtMs: number | null;
  issuedAgoMs: number | null;
  expiresInMs: number | null;
} => {
  if (!token) {
    return {
      tokenResolved: false,
      tokenLength: null,
      signatureSuffix: null,
      subject: null,
      issuedAtMs: null,
      expiresAtMs: null,
      issuedAgoMs: null,
      expiresInMs: null,
    };
  }
  const segments = token.split('.');
  const payloadSegment = segments[1];
  const signatureSegment = segments[2];
  let payload: JwtPayloadRecord | null = null;
  if (payloadSegment) {
    const decoded = decodeBase64Url(payloadSegment);
    if (decoded) {
      try {
        const parsed: unknown = JSON.parse(decoded);
        if (parsed && typeof parsed === 'object') {
          payload = parsed as JwtPayloadRecord;
        }
      } catch {
        // Best-effort diagnostics only.
      }
    }
  }
  const now = Date.now();
  const iatSeconds = typeof payload?.iat === 'number' ? payload.iat : null;
  const expSeconds = typeof payload?.exp === 'number' ? payload.exp : null;
  const issuedAtMs = iatSeconds !== null ? iatSeconds * 1000 : null;
  const expiresAtMs = expSeconds !== null ? expSeconds * 1000 : null;
  return {
    tokenResolved: true,
    tokenLength: token.length,
    signatureSuffix:
      typeof signatureSegment === 'string' && signatureSegment.length > 8
        ? signatureSegment.slice(-8)
        : signatureSegment,
    subject:
      typeof payload?.sub === 'string'
        ? payload.sub
        : typeof payload?.userId === 'string'
          ? payload.userId
          : null,
    issuedAtMs,
    expiresAtMs,
    issuedAgoMs: issuedAtMs !== null ? now - issuedAtMs : null,
    expiresInMs: expiresAtMs !== null ? expiresAtMs - now : null,
  };
};
